module.exports = __webpack_public_path__ + "img/Avatar-76.bbfae09b.svg";